import { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';

import { MenuIcon, Nav, NavbarContainer, NavItem, NavLink, NavLogo, NavMenu, NavBtn, NavBtnLink, NavLink2, Nav2 } from './styles.js';

import logoImg from '../../assets/logo-pantheon.png'

export function Navbar({ toggle }) {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav2 scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to='/' onClick={toggleHome}>
              <img src={logoImg} alt="logo" />
            </NavLogo>
            <MenuIcon onClick={toggle}>
              <FaBars />
            </MenuIcon>
            <NavMenu>
              <NavItem>
                <NavLink2 smooth={true} duration={500} spy={true} exact='true' offset={-80} href='#' >Inicio</NavLink2>
              </NavItem>
              <NavItem>
                <NavLink2 smooth={true} duration={500} spy={true} exact='true' offset={-80} href='#' >Aulas</NavLink2>
              </NavItem>
              <NavItem>
                <NavLink2 smooth={true} duration={500} spy={true} exact='true' offset={-80} href='#' >Disciplina</NavLink2>
              </NavItem>
              <NavItem>
                <NavLink to='about' smooth={true} duration={500} spy={true} exact='true' offset={-80} >Sobre</NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink to='discover' smooth={true} duration={500} spy={true} exact='true' offset={-80}>Funcionamento</NavLink>
              </NavItem> */}
              {/* <NavItem>
                        <NavLink to='services' smooth={true} duration={500} spy={true} exact='true' offset={-80}>Serviços</NavLink>
                    </NavItem> */}
              {/* <NavItem>
                        <NavLink to='signup' smooth={true} duration={500} spy={true} exact='true' offset={-80}>Cadastre-se</NavLink>
                    </NavItem> */}
            </NavMenu>
            <NavBtn>
              <NavBtnLink to="/login">Acessar</NavBtnLink>
            </NavBtn>
          </NavbarContainer>
        </Nav2>
      </IconContext.Provider>
    </>
  )
}